// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__fipzH","errorFallback":"styles_errorFallback__3Zq1m","errorText":"styles_errorText__geRSd"};